import CompradorDespachoOverview from "@/components/despacho/CompradorDespachoOverview";
import { DespachoPageShell } from "@/components/despacho/DespachoUi";

/**
 * Pantalla de diseño — resumen comercial del comprador/despacho (mock + entitlements de solo lectura).
 */
export default function CompradorDespachoPage() {
  return (
    <DespachoPageShell
      title="Comprador / despacho"
      subtitle="Consulta módulos contratados, vigencias y límites autorizados."
      testId="despacho-comprador-page"
    >
      <CompradorDespachoOverview />
    </DespachoPageShell>
  );
}
